import type { EnvironmentId } from "@cmmd-forge/contracts";

export const projectQueryKeys = {
  all: ["projects"] as const,
  searchContents: (
    environmentId: EnvironmentId | null,
    cwd: string | null,
    query: string,
    limit: number,
    caseSensitive: boolean,
    wholeWord: boolean,
    useRegex: boolean,
  ) =>
    [
      "projects",
      "search-contents",
      environmentId ?? null,
      cwd,
      query,
      limit,
      caseSensitive,
      wholeWord,
      useRegex,
    ] as const,
  searchEntries: (
    environmentId: EnvironmentId | null,
    cwd: string | null,
    query: string,
    limit: number,
  ) => ["projects", "search-entries", environmentId ?? null, cwd, query, limit] as const,
};
